
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 81 81","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#5256cb","stroke-miterlimit":"10","stroke-width":"5.5","d":"M30.273 15.75c-6.287-4.25-12.928-5.135-16.293-1.77-4.25 4.25-1.771 13.548 5.578 20.897 7.35 7.35 16.736 9.829 20.898 5.579 0-5.933 8.412-10.803 18.772-10.803 10.36 0 18.772 4.87 18.772 10.803 0 4.781-5.313 8.854-12.75 10.271m-49.5-20.454C8.314 31.689 3 35.763 3 40.456c0 5.932 8.412 10.803 18.772 10.803 10.36 0 18.772-4.87 18.772-10.803m0 0c5.933 0 10.803 8.412 10.803 18.772 0 10.36-4.87 18.772-10.803 18.772-4.781 0-8.854-5.313-10.271-12.75m10.271-24.794c-4.25-4.25-1.77-13.637 5.579-20.898 7.35-7.26 16.647-9.828 20.897-5.578 3.365 3.365 2.48 10.006-1.77 16.293m-49.5 20.454c-4.25 6.287-5.135 12.928-1.77 16.293 4.25 4.25 13.548 1.683 20.897-5.578 7.35-7.35 9.829-16.647 5.579-20.898-5.933 0-10.803-8.412-10.803-18.772C29.653 11.412 34.523 3 40.456 3c4.781 0 8.854 5.313 10.271 12.75m0 49.5c6.287 4.25 12.928 5.135 16.293 1.77 4.25-4.25 1.683-13.548-5.578-20.897-7.35-7.35-16.647-9.829-20.898-5.579"}})])
          )
        }
      }
    